import React from 'react';
import PromoOverview from './PromoOverview';

/** /once/cp/:code/overview -- QR บนรูปคูปองที่ CMS ออกให้ (views/price/discount/CouponManage.js) */
export default function CouponOverview() {
  return <PromoOverview kind="coupon" />;
}
